import findIndex from 'lodash/findIndex';
import { handleActions } from 'redux-actions';
import { actions } from '../actions/companyModal';
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
    },
    ui: {
        isCompanyModalShown: false,
        cropperOpen: false,
        imageURI: null,
    },
    company: null,
    users: [],
    companyId: null,
};
// Destructure the Company modal actions.
export const { companyModalShow, companyModalHidden, companyModalAddCompany, companyModalAddCompanySucceeded, companyModalAddCompanyFailed, companyModalGetUsers, companyModalGetUsersResult, companyModalUpdateCompany, companyModalUpdateCompanySucceeded, companyModalUpdateCompanyFailed, companyModalUpdateCompanyAvatarResult, companyModalOpenAvatarCropperFileChange, companyModalCloseAvatarCropper, companyModalGetPresignedUrl, companyModalGetPresignedUrlFailed, companyModalAvatarUploadFailed, } = actions;
const companyModal = handleActions({
    // Get presigned avatar failed.
    [companyModalGetPresignedUrlFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    // Upload avatar failed.
    [companyModalAvatarUploadFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    // Get presigned url for upload new avatar.
    [companyModalGetPresignedUrl.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { cropperOpen: false }), meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    // Handle open avatar cropper modal.
    [companyModalOpenAvatarCropperFileChange.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { cropperOpen: true, imageURI: action.payload }) });
    },
    // Close avatar modal cropper.
    [companyModalCloseAvatarCropper.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { cropperOpen: false, imageURI: null }) });
    },
    // Show company modal.
    [companyModalShow.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isCompanyModalShown: true }), companyId: action.payload !== undefined &&
                action.payload.company !== undefined &&
                action.payload.company !== null &&
                action.payload.company.id !== undefined &&
                action.payload.company.id !== null
                ? action.payload.company.id
                : null, company: action.payload !== undefined &&
                action.payload.company !== undefined &&
                action.payload.company !== null
                ? action.payload.company
                : null });
    },
    // Hide company modal.
    [companyModalHidden.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isCompanyModalShown: false }), company: null, companyId: null, users: [] });
    },
    // Call add company.
    [companyModalAddCompany.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    // Call update company.
    [companyModalUpdateCompany.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    // Add new company result.
    [companyModalAddCompanySucceeded.toString()]: {
        next(state, action) {
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isCompanyModalShown: false }) });
        },
        throw(state, action) {
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
        },
    },
    [companyModalAddCompanyFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    // Update company succeeded.
    [companyModalUpdateCompanySucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isCompanyModalShown: false }) });
    },
    // Update company failed.
    [companyModalUpdateCompanyFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    // Get related users result (support recusive fetch).
    [companyModalGetUsersResult.toString()]: {
        next(state, action) {
            const users = Object.assign([], state.users);
            for (const user of action.payload.data.users) {
                const foundUserIndex = findIndex(users, { id: user.id });
                if (foundUserIndex > -1) {
                    users[foundUserIndex] = user;
                }
                else {
                    users.push(user);
                }
            }
            return Object.assign(Object.assign({}, state), { users: users, meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
        },
        throw(state, action) {
            return Object.assign(Object.assign({}, state), { users: [], meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
        },
    },
    // Update company with new avatar result.
    [companyModalUpdateCompanyAvatarResult.toString()]: {
        next(state, action) {
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), company: action.payload.data });
        },
        throw(state, action) {
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
        },
    },
}, initialState);
export default companyModal;
